/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type NotificationForegroundMessageWire = {
    type: NotificationForegroundMessageWire.type;
    payload: {
        clientId: string;
        isForeground: boolean;
        observedAt: number;
        endpointId: string;
    };
};
export namespace NotificationForegroundMessageWire {
    export enum type {
        NOTIFICATIONS_FOREGROUND = 'notifications.foreground',
    }
}

